export const DEFAULT_HOT_TOAST_STYLE = {
  'margin-top': '1rem',
  padding: '1rem',
  'font-weight': 500,
  'font-size': '0.95rem',
  'work-break': 'normal',
};
